import { Link } from 'react-router-dom';
import { Building2, ArrowLeft } from 'lucide-react';

export function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="legal-page">
      <nav className="border-b border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Building2 className="h-7 w-7 text-emerald-600" />
            <span
              className="font-bold text-lg text-slate-900"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Kivera
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm text-slate-500 hover:text-slate-900 flex items-center gap-1"
            data-testid="back-to-home"
          >
            <ArrowLeft className="h-3 w-3" /> Startseite
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <h1
          className="text-4xl sm:text-5xl font-bold text-slate-900 mb-8"
          style={{ fontFamily: 'Manrope, sans-serif' }}
        >
          {title}
        </h1>
        <div className="space-y-4 text-slate-700 leading-relaxed [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-slate-900 [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-slate-700 [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_li]:text-slate-700 [&_strong]:text-slate-900 [&_strong]:font-semibold [&_a]:text-emerald-600 [&_a:hover]:text-emerald-700 [&_a]:underline">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link to="/impressum" className="text-slate-500 hover:text-slate-900">Impressum</Link>
          <Link to="/datenschutz" className="text-slate-500 hover:text-slate-900">Datenschutz</Link>
          <Link to="/agb" className="text-slate-500 hover:text-slate-900">AGB</Link>
          <Link to="/roadmap" className="text-slate-500 hover:text-slate-900">Roadmap</Link>
        </div>
      </main>
    </div>
  );
}
